import { defineComponent, onBeforeUnmount, onMounted, ref } from '@vue/composition-api';
import Components from './Overlay/Components.ts.vue';
import Fps from './Overlay/Fps.ts.vue';
import Memory from './Overlay/Memory.ts.vue';
import { getCurrentFps, startFpsTracker, stopFpsTracker } from './fps';
import { getMemoryUsage } from './memory';
import { getComponentCount } from './vue-inspect';
export default defineComponent({
    name: 'PerfOverlay',
    components: {
        Components,
        Fps,
        Memory,
    },
    setup() {
        const memoryUsage = ref(getMemoryUsage());
        const updateMemoryUsage = () => {
            memoryUsage.value = getMemoryUsage();
        };
        const currentFps = ref(0);
        const updateFps = () => {
            currentFps.value = getCurrentFps();
        };
        const componentCount = ref(0);
        const updateComponentCount = () => {
            componentCount.value = getComponentCount();
        };
        const updateTimer = ref(null);
        const setupUpdater = () => {
            startFpsTracker();
            updateTimer.value = window.setInterval(() => {
                updateMemoryUsage();
                updateFps();
                updateComponentCount();
            }, 1000);
        };
        const stopUpdater = () => {
            const { value: timer } = updateTimer;
            if (timer !== null) {
                clearInterval(timer);
            }
            stopFpsTracker();
        };
        onMounted(setupUpdater);
        onBeforeUnmount(stopUpdater);
        return {
            memoryUsage,
            currentFps,
            componentCount,
        };
    },
});
